import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
});

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const sendChat = (session_id, message) =>
  api.post("/chat", { session_id, message }).then((r) => r.data);

export const createCheckoutSession = (payload) =>
  api.post("/checkout/session", payload).then((r) => r.data);

export const getCheckoutStatus = (session_id) =>
  api.get(`/checkout/status/${session_id}`).then((r) => r.data);

// ---- admin ----
const ADMIN_TOKEN_KEY = "ge_admin_token";

export const adminToken = {
  get: () => localStorage.getItem(ADMIN_TOKEN_KEY) || "",
  set: (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t),
  clear: () => localStorage.removeItem(ADMIN_TOKEN_KEY),
};

export const adminLogin = (username, password) =>
  api.post("/admin/login", { username, password }).then((r) => r.data);

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${adminToken.get()}` },
});

export const adminMe = () => api.get("/admin/me", authHeaders()).then((r) => r.data);
export const adminStats = () =>
  api.get("/admin/stats", authHeaders()).then((r) => r.data);
export const adminListLeads = () =>
  api.get("/leads", authHeaders()).then((r) => r.data);
export const adminListPayments = () =>
  api.get("/admin/payments", authHeaders()).then((r) => r.data);
export const adminListCommunity = () =>
  api.get("/admin/community", authHeaders()).then((r) => r.data);
export const adminApproveCommunity = (id) =>
  api.post(`/admin/community/${id}/approve`, {}, authHeaders()).then((r) => r.data);
export const adminRejectCommunity = (id) =>
  api.post(`/admin/community/${id}/reject`, {}, authHeaders()).then((r) => r.data);

// ---- Community public flow ----
export const communityInfo = () =>
  api.get("/community/info").then((r) => r.data);

export const communityRegister = (payload) =>
  api.post("/community/register", payload).then((r) => r.data);

export const communityPayment = (payload) =>
  api.post("/community/payment", payload).then((r) => r.data);

export const communityStatus = (signup_id) =>
  api.get(`/community/status/${signup_id}`).then((r) => r.data);
